export default "__VITE_ASSET__KiY$9PL$__"